module.exports = "/davinci/assets/8fbdfe6439191405b1600c30aa813ab0.png";